import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 19px;

  .mobile & {
    flex-direction: column-reverse;
    > div {
      width: 100%;
      max-width: 100%;

      > div {
        max-width: 100%;
        padding: 0;
      }
    }
  }
`;